import { toast } from 'react-toastify';
import { storeOrgFeatures } from '../FocusMode/Zavvy/orgFeatures';
import { handleRedirection } from '../../Utils/useRoleRedirection';
import {
  clearOrgIndustryTypesCache,
  clearFrameworkMappingsCache,
  seedPermissionContext,
  isTrinityPortal,
  isTrinityAllowedRole,
} from '../../Utils/adminUserTypes';

export const applyLoginSession = async ({ response, login, navigate }) => {
  if (response?.status !== 200) {
    toast.error('User not found.');
    return false;
  }
  const token = response?.data?.access_token;
  const loginRole = response?.data?.user?.Role || response?.data?.user?.role;
  if (isTrinityPortal() && !isTrinityAllowedRole(loginRole)) {
    const loginOrg = response?.data?.user?.OrgName || response?.data?.user?.organization_name || '';
    const shownRole = loginRole || 'unknown role';
    const where = loginOrg ? `${shownRole} on ${loginOrg}` : shownRole;
    toast.error(
      `Admin portal access denied. Signed in as ${where}. This portal accepts Super Admin - Admin or Tech Admin - Admin on the active organization.`,
      { autoClose: 8000 }
    );
    return false;
  }
  clearOrgIndustryTypesCache();
  clearFrameworkMappingsCache();
  localStorage.setItem('subscription_status', response?.data?.user?.SubscriptionStatus);
  localStorage.setItem('Subscription_remaining_days', response?.data?.user?.SubscriptionRemainingDays);
  localStorage.setItem(
    'account_expiration_day',
    String(response?.data?.user?.AccountExpirationDay ?? '')
  );
  localStorage.setItem('userType', response?.data?.user?.Role);
  localStorage.setItem('organizationId', response?.data?.user?.OrganizationID);
  localStorage.setItem('organizationName', response?.data?.user?.OrgName);
  localStorage.setItem('accountId', response?.data?.user?.AccountID);
  localStorage.setItem('userLogindata', JSON.stringify(response?.data?.user));
  if (!localStorage.getItem('mode')) localStorage.setItem('mode', 'Focus Mode');
  if (response?.data?.menu_permissions) {
    localStorage.setItem('menuPermissions', JSON.stringify(response.data.menu_permissions));
  } else {
    localStorage.removeItem('menuPermissions');
  }
  seedPermissionContext(
    response?.data?.framework_menu_mappings ?? null,
    response?.data?.org_industry_types ?? null
  );
  storeOrgFeatures(response?.data?.org_features);
  login(token);
  if (isTrinityPortal()) {
    navigate('/dashboard');
  } else {
    await handleRedirection(navigate, response?.data?.user, response?.data?.user?.OrganizationID, false);
  }
  toast.success('Login Successful.');
  return true;
};
